import { __ } from '@wordpress/i18n';

const outputTypes = [
  {
    label: __('Annual % Change', 'hst'),
    value: '%change',
  },
  {
    label: __('Annual % Change - Inflation Adjusted', 'hst'),
    value: '%change-adjusted',
  },
  {
    label: __('Annual % Change Per Capita', 'hst'),
    value: '%change-pop',
  },
  {
    label: __('Annual % Change Per Capita - Inflation Adjusted', 'hst'),
    value: '%change-pop-adjusted',
  },
  {
    label: __('As a % of GDP', 'hst'),
    value: '%gdp',
  },
  {
    label: __('U.S. $ Billions', 'hst'),
    value: '$billions',
  },
  {
    label: __('U.S. $ Billions - Inflation Adjusted', 'hst'),
    value: '$billions-adjusted',
  },
  {
    label: __('U.S. $ Per Capita', 'hst'),
    value: '$pop',
  },
  {
    label: __('U.S. $ Per Capita - Inflation Adjusted', 'hst'),
    value: '$pop-adjusted',
  },
];

export default outputTypes;
